import styled from "styled-components";

export const Content = styled.div`
  width: 100%;
  padding: 2rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: column;
`;

export const Button = styled.button`
  border-radius: 2.5rem;
  background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.08) 100%
    ),
    #484888;
  box-shadow: 0px 12px 24px -6px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 5rem;

  color: #fff;
  text-align: center;
  font-family: "Avenir-Medium";
  font-size: 1.8rem;
  letter-spacing: -0.178px;
  border: none;
  outline: none;
  user-select: none;

  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:active {
    scale: 0.95;
  }
`;

export const Text = styled.span`
  color: #222239;
  text-align: center;
  font-family: "Avenir-Light";
  text-align: center;
  user-select: none;
  font-size: 2rem;
  letter-spacing: -0.267px;
`;

export const Title = styled.span`
  color: #222239;
  font-family: "FrankfurterEF-Medium";
  font-size: 3rem;
  text-align: center;
  user-select: none;
  letter-spacing: -0.267px;
`;

export const Img = styled.img`
  user-select: none;
  background-color: transparent;
  width: 65px;
  height: 65px;
`;
